export default "__VITE_ASSET__6ae0bcb2__"